import './src/styles/global.css'
import { wrapRootElement as wrapRootElementHelper } from './src/utils/gatsby'

// eslint-disable-next-line import/prefer-default-export
export const wrapRootElement = wrapRootElementHelper
